var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "#FFECEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#FF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1251 36.4062C28.1407 37.4297 28.9766 38.25 30.0001 38.25C31.0235 38.25 31.8594 37.4219 31.8751 36.4062L32.5001 19.5625C32.5391 18.9219 32.3047 18.2969 31.8516 17.8125C31.3672 17.2969 30.6954 17 30.0001 17C29.3047 17 28.6329 17.2969 28.1485 17.8125C27.6954 18.2969 27.461 18.9219 27.5001 19.5625L28.1251 36.4062Z",
    fill: "#FF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 47C31.3807 47 32.5 45.8807 32.5 44.5C32.5 43.1193 31.3807 42 30 42C28.6193 42 27.5 43.1193 27.5 44.5C27.5 45.8807 28.6193 47 30 47Z",
    fill: "#FF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.8f5475cd402c4a2d5cc53fe07147150e.svg";
export { ForwardRef as ReactComponent };